// src/utils/renderMarkdown.ts

import { parse } from "marked";
import { filterXSS } from "xss";

export const renderMarkdown = (markdown: string) => {
  if (!markdown) return "";
  const html = parse(markdown) as string;
  return filterXSS(html);
};
